/**
 * OverlayProvider — App-level context provider for all AI Farm overlays.
 *
 * Composes:
 *   - Radix TooltipProvider (hover tooltips)
 *   - ToastProvider (imperative toasts via useToast hook)
 *
 * Must wrap the entire app. Mounted in main.jsx.
 *
 * See: docs/architecture/OVERLAY_ARCHITECTURE.md §7.2
 */

import React from 'react';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import { ToastProvider } from './Toast';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {number} [props.tooltipDelay=300]
 */
export function OverlayProvider({ children, tooltipDelay = 300 }) {
  return (
    <TooltipProvider delayDuration={tooltipDelay} skipDelayDuration={100}>
      <ToastProvider>
        {children}
      </ToastProvider>
    </TooltipProvider>
  );
}

OverlayProvider.displayName = 'OverlayProvider';
